import { render, staticRenderFns } from "./BaseBlockButton.vue?vue&type=template&id=4a918b1a&scoped=true"
import script from "./BaseBlockButton.vue?vue&type=script&lang=js"
export * from "./BaseBlockButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a918b1a",
  null
  
)

export default component.exports